import moment from 'moment';

export function calcOpacity(settings, zoom) {
    let opacity = settings.lower.opacity;

    if (zoom < settings.lower.zoom) {
        opacity = settings.lower.opacity;

    } else if (zoom < settings.upper.zoom) {
        opacity = (settings.upper.opacity - settings.lower.opacity)
            * (zoom - settings.lower.zoom) / (settings.upper.zoom - settings.lower.zoom)
            + settings.lower.opacity;

    } else {
        opacity = settings.upper.opacity;
    }

    return opacity;
}

// 時刻を表す文字列（ UTC ）から Date オブジェクトを返す。
export function toDate(YYYYMMDDhhmm) {
    return new Date(`${YYYYMMDDhhmm.substr(0, 4)}-${YYYYMMDDhhmm.substr(4, 2)}-${YYYYMMDDhhmm.substr(6, 2)}T${YYYYMMDDhhmm.substr(8, 2)}:${YYYYMMDDhhmm.substr(10, 2)}Z`);
}

// 時刻タイトルの文字列を返す。
export function datetimeTitle(datetime) {
    if (datetime.getMinutes() === 0) {
        // 分がゼロの時は分を省略する。
        return moment(datetime).format("M月D日 H時");

    } else {
        return moment(datetime).format("M月D日 H時m分");
    }
}